const Q = require(`q`);
const _ = require(`underscore`);
const __request = require(`./__request/__request_contentType_json`);

// 改签车次余票接口文档地址：http://192.168.0.11:9900/doc.html#/trains/product-controller/selectEndorsedToSearchUsingPOST
const trains_product_selectEndorsedToSearch = (pParameter) => {
  if (!pParameter) pParameter = {};
  const p = {
    method: 'post',
    urlSuffix: '/trains/product/selectEndorsedToSearch',
    data: pParameter,
  };
  return Q.when()
    .then(function () {
      return __request(p);
    })
    .then(function (data) {
      return Q.resolve(data);
    })
    .catch(function (ex) {
      console.error(ex);
      if (ex) {
        if (ex.stack) {
          console.error(ex.stack);
        }
      }
      return Q.reject(ex);
    })
    ;
};
module.exports = trains_product_selectEndorsedToSearch;
